export default __webpack_public_path__ + "static/CharlieDisplay-Regular-32609fbd4e4118982bb949f9bfdc8a9f.otf";